export default __webpack_public_path__ + "static/media/lowestAsk.9cb6d319.svg";